// extracted by mini-css-extract-plugin
export default {"releaseNotesPage":"ReleaseNotesPage_releaseNotesPage__bmUPr","pageHeading":"ReleaseNotesPage_pageHeading__tieGA","paragraph":"ReleaseNotesPage_paragraph__LLG9X"};